import { CartUpdateEvent } from '@theme/events';

/**
 * Updates the cart bubble display
 */
function updateCartBubble(count) {
  const bubble = document.querySelector('.header-hangar__cart-bubble');
  if (!bubble) return;

  const countNum = Number(count) || 0;

  if (countNum > 0) {
    bubble.textContent = String(countNum);
    if (bubble.style) {
      bubble.style.display = 'flex';
    }
  } else {
    if (bubble.style) {
      bubble.style.display = 'none';
    }
  }
}

/**
 * Fetches the current cart and updates the bubble with the true item count
 */
async function refreshCartBubble() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) return;
    const cart = await response.json();
    updateCartBubble(cart.item_count);
  } catch (error) {
    // Silently fail — bubble will correct itself on next interaction or page load
  }
}

document.addEventListener('cart:update', () => {
  refreshCartBubble();
});
